export default function EncoursConfiguration($translatePartialLoaderProvider) {
    $translatePartialLoaderProvider.addPart('encours');
}

EncoursConfiguration.$inject = ['$translatePartialLoaderProvider'];
